import { render, staticRenderFns } from "./CreateWebshop.vue?vue&type=template&id=0bad265c&scoped=true&"
import script from "./CreateWebshop.vue?vue&type=script&lang=js&"
export * from "./CreateWebshop.vue?vue&type=script&lang=js&"
import style0 from "./CreateWebshop.vue?vue&type=style&index=0&id=0bad265c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad265c",
  null
  
)

export default component.exports